import { Outlet } from "react-router-dom";

const MainPayments = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainPayments;